import { Colors } from '@doordash/design-language'
import styled from 'styled-components'

type SelectableType = { isSelected: boolean }

export const Orientation = styled.div`
  padding: 12px;
  width: 112px;
  cursor: pointer;
  border: 1px solid;
  border-radius: 4px;
  margin-right: 11px;
  margin-left: 11px;

  @media (min-width: 321px) {
    margin-right: 24px;
    margin-left: 24px;
  }

  border-color: ${(p: SelectableType) =>
    p.isSelected ? Colors.SystemTeal60 : Colors.SystemGrey20};
  background-color: ${(p: SelectableType) =>
    p.isSelected ? Colors.SystemTeal60 : Colors.SystemWhite};
  &:hover {
    background-color: ${(p: SelectableType) =>
      p.isSelected ? Colors.SystemTeal60 : Colors.SystemGrey0};
  }
`
